export default (string) => string.replace(/`/g, '\\`')
